import React from "react";
import { RouteComponentProps } from "@reach/router";

import Layout from "../components/layout";
// import SEO from "../components/seo";

interface NotFoundPageProps extends RouteComponentProps {
  title: string;
}

const NotFoundPage = (props: NotFoundPageProps) => (
  <Layout title={props.title}>
    <h1>NOT FOUND</h1>
    <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
  </Layout>
);

export default NotFoundPage;
